<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{title}}</h4>
</div>
<div class="modal-body">
	<div class="row">
		<div class="col-xs-12">
			<div>{{{hint}}}</div>
		</div>
	</div>


	{{#if sourceDeviceInfos}}
	<div class="row">
		<div class="col-xs-12">
			<div class="alert alert-danger m-t-20 m-b-10">
				<strong>{{TR "Achtung"}}</strong>: {{TR "Sie löschen Geräte die Quellen eines Fremdwertbezugs sind."}}<br>
				{{TR "Der Fremdwertbezug wird beendet."}}
			</div>
		</div>
	</div>
	{{/if}}

	<div style="max-height:400px;overflow-x:hidden;overflow-y:auto">
		{{#each sourceDeviceInfos}}
		<div class="row">
			<div class="col-xs-10">
				<h5 class="heading long">{{{COLUMN_DATA device "#_name_link" undefined}}}</h5>
			</div >
		</div>
		{{#each targets}}
		<div class="row m-b-10">
			{{#if this.andMore}}
				<div class="m-l-20">... {{TR "weitere Zielgeräte"}}</div>
			{{else}}
				<div class="col-xs-8">
					<div class="m-l-10">→ {{{COLUMN_DATA device "#_name_link" undefined}}}</div>
				</div>
				<div class="col-xs-4">
					{{#each data_points}}
					<span>{{this}}</span><br>
					{{/each}}
				</div>
			{{/if}}
		</div>
		{{/each}}
		{{/each}}
	</div>


</div>
<div class="modal-footer">
	{{#if action_label}}
	<button id="ct-cancel" type="button" class="btn btn-white" data-dismiss="modal">
		{{#if cancel_label}}{{cancel_label}}{{else}}{{TR "Abbrechen"}}{{/if}}
	</button>
	<a class="btn btn-primary ct-confirm-dialog" id="js-action">{{action_label}}</a>
	{{else}}
	<button id="ct-ok" type="button" class="btn btn-white" data-dismiss="modal">
		{{TR "OK"}}
	</button>
	{{/if}}
</div>
